@if (isInputTypeNumber) {
  <input type="text"
    numbersOnly
    maxlength="9"
    [(ngModel)]="inputText"
    (keydown.enter)="onEnter()"
    [disabled]="!isInputActive"
    class="input-criteria-type-text"
    data-cy="input-criteria-type-text"
    [ngClass]="{'active': isInputActive}"
    [placeholder]="dynamicInputPlaceholder"/>
}

@if (!isInputTypeNumber) {
  <input type="text"
    [(ngModel)]="inputText"
    (keydown.enter)="onEnter()"
    [disabled]="!isInputActive"
    class="input-criteria-type-text"
    data-cy="input-criteria-type-text-string"
    [ngClass]="{'active': isInputActive}"
    [placeholder]="dynamicInputPlaceholder"/>
}
